import React from 'react';

function About() {
  return (
    <div>
      <div className="header">
        <h1>About Us</h1>
      </div>

      <div className="container">
        <div className="content">
          <h2>Our Mission</h2>
          <p>To provide accessible, reliable, and ethical financial services to our members while promoting financial inclusion and sustainable development across Maharashtra and Karnataka.</p>

          <h2>Our Values</h2>
          <p><strong>Integrity:</strong> We operate with complete transparency and honesty in all our dealings.</p>
          <p><strong>Member-Centric:</strong> Our members' interests are at the heart of everything we do.</p>
          <p><strong>Community Focus:</strong> We believe in building strong communities through cooperative banking.</p>
          <p><strong>Excellence:</strong> We strive for the highest standards in service delivery.</p>

          <h2>Contact Us</h2>
          <p>Email: info@sarayuurbanmultistate.com</p>
          <p>Phone: +91-9699665737</p>
        </div>
      </div>
    </div>
  );
}

export default About;